export const defaultExceptionType = 'Error';
//# sourceMappingURL=const.js.map